module.exports = __webpack_public_path__ + "static/media/active_video_thumb1.d0706e83.svg";